import extend from 'lowscore/extend.js'
import obfuscateUrlPassword from 'httpism/obfuscateUrlPassword.js'

export default function (req, next) {
  return next().then(response => {
    if (
      response.headers['x-long-response'] == 'true' &&
      (response.body instanceof Object &&
        typeof response.body.pipe !== 'function')
    ) {
      var exceptions = req.options.exceptions
      var isException = exceptions == false
        ? false
        : typeof exceptions == 'function'
          ? exceptions(response.body)
          : response.body.statusCode >= 400

      if (isException) {
        var obfuscatedUrl = obfuscateUrlPassword(req.url)
        var msg = req.method.toUpperCase() + ' ' + obfuscatedUrl + ' => ' + response.body.statusCode
        var error = new Error(msg)
        error.statusCode = response.body.statusCode
        error.body = response.body.body
        error.url = obfuscatedUrl
        throw error
      }
      return {
        statusCode: response.body.statusCode,
        body: response.body.body,
        url: response.url,
        headers: extend(response.headers, response.body.headers),
      }
    } else {
      return response
    }
  })
}

export const middleware = 'longResponse'
